<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
  <div class="scroll_view">
    <div class="hopital_notice_container">
      <!-- 定位 -->
      <div class="hospital_header">
        <div class="com_card_title">
          <div class="title">我的关注</div>
          <div class="location" @click="clickHandle">
            <i class="iconfont icondingwei2"></i>
            <template v-if="areaValue.length">
              <span style="margin:0 5px;">{{areaValue[0].name}}</span>
              <span>{{areaValue[1].name}}</span>
            </template>
            <template v-else>
              <span style="margin-left:5px;">{{this.province}}</span>
              <span style="margin-left:5px;">{{this.city}}</span>
            </template>
            <span style="color:#999999;margin-left:4px;">
              <Icon name="arrow-down" />
            </span>
          </div>
        </div>
      </div>
      <div class="sum_date_message">
        截止<span>{{lastUpdateTime}}</span>, 共<span>{{total}}</span>家医院
      </div>
    
      <SimpleCard v-for="(item,index) in listData" :key="index" :title='item.hospital' :isNew="item.is_new" style="border-bottom:1px solid #F1EFF2;" class='van-clearfix' @click="handleClick(item)">
        <div class="content" style="color:#666666">{{item.title}}</div>
        <div slot="footer" class="footer">
          <!-- <div class="label_wrap">
            <label class="label">来源：</label>
            <div class="txt">{{item.source}}</div>
          </div> -->
          <div class="label_wrap">
            <label class="label">发布日期：</label>
            <div class="txt">{{item.publish_date}}</div>
          </div>
        </div>
      </SimpleCard>
      <div><Chatbot /></div>
    </div>
    <!-- 空 -->
    <div class="empty" v-if="listData.length === 0">
      <Empty />
    </div>
    <!-- 城市选择 -->
    <van-popup 
      v-model="show"
      position="bottom"
      :style="{ height: '30%' }"  
    >
      <van-area 
        :area-list="areaList" 
        @confirm="confirmHandle"
        :columns-num="2"
        @cancel="cancelHandle"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Area, Popup } from 'vant';
import areaListData from '@/data/area'
import { debounce,statisticalHandle, getDate } from 'utils/baseMethods.js'
import { HttpRequest} from 'utils/'
import { Toast } from 'vant'
export default {
  name:'HospitalNotice',
  data() {
    return {
      areaList:areaListData,
      show:false,
      loading: false,
      finished: false,
      listData: [],
      pageSize:0,
      total:0,
      lastUpdateTime:'',
      areaValue:[]
    }
  },
  components:{
    [Area.name]: Area,
    [Popup.name]: Popup
  },
  computed:{
    ...mapState('location', ['city','province','area'])
  },
  watch:{
    area:{
      handler:function(value){
        // 如果没有地址 那么就获取默认地址
        if (!this.$route.query.areaValue && value.length ){
          this.areaValue = value
          this.fetchData()
        }
      },
      deep:true,
      immediate:true
    }
  },
  created() {
    try {
      let areaValue = this.$route.query.areaValue
      if (areaValue){
        this.$set(this,'areaValue',JSON.parse(areaValue))
      }
    }catch(e){
      this.areaValue = []
    }
    this.lastUpdateTime = getDate()
    document.title = '医院通告'
    this.fetchData(10)
    this.$nextTick(()=>{
      this.$el.onscroll = debounce(()=>{
        const scrollHeight = this.$el.scrollHeight
        const scrollTop = this.$el.scrollTop
        const clientHeight = this.$el.clientHeight
    
        if(scrollHeight - (clientHeight + scrollTop) <= 50 ){
          if (this.total !== this.listData.length) {
            this.fetchData(this.pageSize + 10)
          }
        }
      },100)
    })
    this.$store.dispatch('location/getLocation')
  },
  methods:{
    handleClick(item){
      if (item.url) {
        this.$router.push({
          query:{
            areaValue:JSON.stringify(this.areaValue)
          }
        })
        statisticalHandle(item)
        window.open(item.url)
        return 
      } 
      Toast.fail('跳转链接错误，请联系管理员');
    },
    clickHandle() {
      this.show = true
    },
    confirmHandle(data) {
      this.show = false
      this.areaValue = data
      this.fetchData()
    },
    cancelHandle() {
      this.show = false
    },
    async fetchData(pageSize = this.pageSize){
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
     const response = await HttpRequest({
        url:'/professional/hospital_notices/',
        params:{
          page:1,
          page_size:pageSize,
          county_code:'',
          city_code: this.areaValue[1] ?this.areaValue[1].code + '' :'',
          province_code:this.areaValue[0] ? this.areaValue[0].code + '' : '',
        }
      })
      Toast.clear()
      this.total = response.count
      this.pageSize = response.page_size,
      // this.lastUpdateTime  = response.last_add_time
      this.listData = response.results
      return response
    },
    clickJumpHandle(item) {
      window.open(item.url)
    }
  }
}
</script>

